import { Injectable } from '@angular/core';
import { EventQueueService } from './event-queue-service.service';
import {AktionService} from "./aktion.service";
import {AnmeldungService} from "./anmeldung.service";
import {AnmeldungHistoryService} from "./anmeldungs-history.service";
import {AusgabenService} from "./ausgaben.service";
import {ElternService} from "./eltern.service";
import {IconService} from "./icon.service";
import {KindService} from "./kind.service";
import {RechnungService} from "./rechnung.service";
import {IAktion} from "../models/IAktion.interface";
import {IAnmeldung} from "../models/IAnmeldung.interface";
import {IAusgaben} from "../models/IAusgaben.interface";
import {IEltern} from "../models/IEltern.interface";
import {IIcon} from "../models/IIcon.interface";
import {IKind} from "../models/IKind.interface";
import {IRechnung} from "../models/IRechnungModel";

@Injectable({
  providedIn: 'root'
})
export class CheatServiceService {

  private _isLoading = false;

  constructor(
    private aktionService: AktionService,
    private anmeldungService: AnmeldungService,
    private anmeldungHistoryService: AnmeldungHistoryService,
    private ausgabenService: AusgabenService,
    private elternService: ElternService,
    private iconService: IconService,
    private kindService: KindService,
    private eventQueue: EventQueueService,
    private rechnungService: RechnungService
  ) {
    (window as any).aktionService = this.aktionService;
    (window as any).anmeldungService = this.anmeldungService;
    (window as any).anmeldungHistoryService = this.anmeldungHistoryService;
    (window as any).ausgabenService = this.ausgabenService;
    (window as any).elternService = this.elternService;
    (window as any).iconService = this.iconService;
    (window as any).kindService = this.kindService;
    (window as any).rechnungService = this.rechnungService;



    eventQueue.getObservable().subscribe((msg) => {
      switch (msg) {
        case "permissionChange":
        case "relaod":
          this.update();
          break;
        default:
          break;
      }
    })
  }


  public async update() {
    this._isLoading = true;
    return new Promise((resolve, reject) => {
      const serviceCount = 7;
      let i = 0;

      let aktionServiceState: IAktion[];
      let anmeldungServiceState: IAnmeldung[];
      let ausgabenServiceState: IAusgaben[];
      let elternServiceState: IEltern[];
      let iconServiceState: IIcon[];
      let kindServiceState: IKind[];
      let rechnungServiceState: IRechnung[];

      const serviceInitDone = () => {
        i++;
        if (i === serviceCount) {

          this.aktionService.updateState(aktionServiceState);
          this.anmeldungService.updateState(anmeldungServiceState);
          this.ausgabenService.updateState(ausgabenServiceState);
          this.elternService.updateState(elternServiceState);
          this.iconService.updateState(iconServiceState);
          this.kindService.updateState(kindServiceState);
          this.rechnungService.updateState(rechnungServiceState);

          this.eventQueue.fireEvent("initDone");
          this._isLoading = false;
          resolve();
        }
      };

      this.aktionService.updateData(false).then(r => aktionServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.anmeldungService.updateData(false).then(r => anmeldungServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.ausgabenService.updateData(false).then(r => ausgabenServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.elternService.updateData(false).then(r => elternServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.iconService.updateData(false).then(r => iconServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.kindService.updateData(false).then(r => kindServiceState = r).then(serviceInitDone).catch((err) => reject(err));
      this.rechnungService.updateData(false).then(r => rechnungServiceState = r).then(serviceInitDone).catch((err) => reject(err));
    });
  }

  public get isLoading(){
    return this._isLoading;
  }
}
